import { render, staticRenderFns } from "./learnTuition.vue?vue&type=template&id=863ecb98&scoped=true&"
import script from "./learnTuition.vue?vue&type=script&lang=js&"
export * from "./learnTuition.vue?vue&type=script&lang=js&"
import style0 from "./learnTuition.vue?vue&type=style&index=0&id=863ecb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863ecb98",
  null
  
)

export default component.exports